import React from 'react';
import PublicLayout from '../layouts/PublicLayout';

const withPublicLayout = (WrappedComponent) => {
  return (props) => (
    <PublicLayout>
      <WrappedComponent {...props} />
    </PublicLayout>
  );
};

export default withPublicLayout; 